function initCopyToClipbaord() {
  if (!document.querySelector(".copy-to-clipboard")) {
    return null;
  }
  const clickListeners = document.querySelectorAll(".copy-to-clipboard");
  Array.from(clickListeners).forEach(el => {
    el.addEventListener("click", copyToClipboard);
  });

  function copyToClipboard() {
    const { id } = this;
    const { href } = window.location;
    const url = `${href}#${id}`;

    const input = createInput(url);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);

    const msgElement = document.createElement("DIV");
    msgElement.classList.add("msg-copied--success");
    msgElement.innerHTML = `<p>copied link</p>`;
    this.appendChild(msgElement);

    setTimeout(() => this.removeChild(msgElement), 2000);
  }

  function createInput(val) {
    const el = document.createElement("INPUT");
    el.value = val;
    document.body.appendChild(el);
    return el;
  }
}
window.addEventListener("load", initCopyToClipbaord);
